export default __webpack_public_path__ + "static/media/Bell.e1df3726.svg";